var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-layout flex-center position-ref full-height"},[_c('o-child')],1)}
var staticRenderFns = []

export { render, staticRenderFns }